import { t } from "../../../i18n";
import { fmt, type WallResult } from "@tasduvar/engine";
import { InputTable, Section } from "./common";

export function SeismicParams({ result }: { result: WallResult }): JSX.Element {
  const s = result.seismic;
  if (!s) return <Section id="seismicParams" title={t("5. Deprem Parametreleri")}><p className="muted">{t("Deprem hesabı yapılmadı.")}</p></Section>;
  if (s.source === "direct") {
    return (
      <Section id="seismicParams" title={t("5. Deprem Parametreleri (doğrudan katsayı)")}>
        <InputTable rows={[
          { label: t("Yatay statik-eşdeğer deprem katsayısı (kullanıcı girdisi)"), symbol: "kh", value: s.kh, digits: 4 },
          { label: t("Düşey statik-eşdeğer deprem katsayısı (kullanıcı girdisi)"), symbol: "kv", value: s.kv, digits: 4 },
          { label: t("Deprem açısı (1 − kv)"), symbol: "θ = atan[kh/(1−kv)]", value: s.thetaUpDeg, unit: "°", digits: 2 },
          { label: t("Deprem açısı (1 + kv)"), symbol: "θ = atan[kh/(1+kv)]", value: s.thetaDownDeg, unit: "°", digits: 2 },
        ]} />
        <p className="muted">{t("Katsayılar TBDY 2018 Denk. 16.22 ile türetilmedi; yönetmelik uygunluğu ve izin verilen yerdeğiştirme değerlendirmesi kullanıcıya aittir.")}</p>
      </Section>
    );
  }
  return (
    <Section id="seismicParams" title={t("5. Deprem Parametreleri (TBDY 2018 §2.3, §16.12.2)")}>
      <InputTable rows={[
        ...(s.FS !== undefined ? [{ label: t("Kısa periyot yerel zemin etki katsayısı (Tablo 2.1)"), symbol: "FS", value: s.FS, digits: 3 }] : []),
        { label: t("Kısa periyot tasarım spektral ivme katsayısı"), symbol: "SDS = FS·SS", value: s.SDS ?? 0, digits: 3 },
        ...(s.SD1 !== undefined ? [{ label: "1,0 s tasarım spektral ivme katsayısı", symbol: "SD1 = F1·S1", value: s.SD1, digits: 3 }] : []),
        { label: t("Duvar tipi katsayısı (Tablo 16.7)"), symbol: "r", value: s.r, digits: 1 },
        { label: t("Yatay statik-eşdeğer deprem katsayısı (Denk. 16.22)"), symbol: "kh = 0,4·SDS/r", value: s.kh, digits: 4 },
        { label: t("Düşey statik-eşdeğer deprem katsayısı"), symbol: "kv = 0,5·kh", value: s.kv, digits: 4 },
        { label: t("Deprem açısı (1 − kv)"), symbol: "θ = atan[kh/(1−kv)]", value: s.thetaUpDeg, unit: "°", digits: 2 },
        { label: t("Deprem açısı (1 + kv)"), symbol: "θ = atan[kh/(1+kv)]", value: s.thetaDownDeg, unit: "°", digits: 2 },
        { label: t("İzin verilen yerdeğiştirme (Tablo 16.7)"), value: s.allowedDisplacementMm === null ? "—" : fmt(s.allowedDisplacementMm, 0), unit: s.allowedDisplacementMm === null ? "" : "mm" },
      ]} />
    </Section>
  );
}
